const LOCATION_CHANGE_EVENT = 'mp-agent:locationchange'
const PATCH_FLAG = '__mp_agent_history_patched__'

const safeDispatch = () => {
  try {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT))
  } catch {
    // ignore
  }
}

const patchHistoryOnce = () => {
  if (typeof window === 'undefined') return
  const w = window as unknown as Record<string, unknown>
  if (w[PATCH_FLAG]) return
  w[PATCH_FLAG] = true

  try {
    const originalPushState = history.pushState
    history.pushState = function (...args: Parameters<History['pushState']>) {
      const ret = originalPushState.apply(this, args as any)
      safeDispatch()
      return ret
    }
  } catch {
    // ignore
  }

  try {
    const originalReplaceState = history.replaceState
    history.replaceState = function (...args: Parameters<History['replaceState']>) {
      const ret = originalReplaceState.apply(this, args as any)
      safeDispatch()
      return ret
    }
  } catch {
    // ignore
  }
}

/**
 * Subscribe to route/location changes in SPAs and classic navigation.
 *
 * - **popstate**: back/forward
 * - **hashchange**: hash routers
 * - **pushState/replaceState**: client routers (patched once)
 */
export const subscribeToLocationChanges = (handler: () => void): (() => void) => {
  if (typeof window === 'undefined') return () => {}
  patchHistoryOnce()

  const onChange = () => handler()
  window.addEventListener('popstate', onChange)
  window.addEventListener('hashchange', onChange)
  window.addEventListener(LOCATION_CHANGE_EVENT, onChange)

  return () => {
    window.removeEventListener('popstate', onChange)
    window.removeEventListener('hashchange', onChange)
    window.removeEventListener(LOCATION_CHANGE_EVENT, onChange)
  }
}

